import { render } from "./GridContacte.vue?vue&type=template&id=7e2b1e2a&ts=true"
import script from "./GridContacte.vue?vue&type=script&lang=ts"
export * from "./GridContacte.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__